import React from 'react'
import { StyleSheet } from '../stylesheet'
import { parseSpotifyLink } from '../../../services/music-player'

export const SpotifyEmbed: React.FC<{ spotifyArtistLink: string; style?: React.CSSProperties }> = ({ spotifyArtistLink, style }) => {
  const player = parseSpotifyLink(spotifyArtistLink)
  if (!player) return null
  return (
    <iframe
      style={{ ...styles.frame, ...style }}
      src={`${player.uri}?utm_source=generator`}
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      loading="lazy"
    />
  )
}

const styles = StyleSheet.create({
  frame: {
    border: 'none',
    borderRadius: 10,
    height: '400px',
    width: '100%',
  },
})
